export default __webpack_public_path__ + "static/media/portfolio-172.3a67b4e0.jpg";